/** Out-of-area leads for geo exclusions (read-only; agency operators). */
import { apiClient } from '@/services/apiClient';

export interface OutOfAreaLead {
  lead_id: string;
  lead_type: string | null;
  date_created: string | null;
  source: string | null;
  reason: string;
  city: string | null;
  state: string | null;
  zip: string | null;
  /** Where the location came from: the phone number (calls) or the form. */
  location_source: string;
  ip_address: string | null;
  campaign: string | null;
}

export interface OutOfAreaResponse {
  tenant_id: string;
  days: number;
  total: number;
  /** Says caller-ID location is a hint, not proof. */
  location_note: string;
  leads: OutOfAreaLead[];
  by_city: Array<{ city: string; state: string | null; count: number }>;
  by_zip: Array<{ zip: string; count: number }>;
}

export async function getOutOfArea(tenantId: string, days: number): Promise<OutOfAreaResponse> {
  const { data } = await apiClient.get<OutOfAreaResponse>('/whatconverts/out-of-area', {
    params: { tenant_id: tenantId, days },
  });
  return data;
}

/** The CSV, as the browser's own download (the server names the file). */
export async function downloadOutOfAreaCsv(tenantId: string, days: number): Promise<void> {
  const { data } = await apiClient.get<Blob>('/whatconverts/out-of-area/export.csv', {
    params: { tenant_id: tenantId, days },
    responseType: 'blob',
  });
  const url = URL.createObjectURL(data);
  const a = document.createElement('a');
  a.href = url;
  a.download = `out-of-area-${tenantId}-${days}d.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
